import React from "react";
import ReactDOM from "react-dom";

const centerModalNew = (props) => {
  const hideModal = () => {
    if (typeof props.onHide === "function") {
      props.onHide();
    }

    if (typeof window !== "undefined" && window.$ && props.modalId) {
      window.$(`#${props.modalId}`).modal("hide");
    }
  };

  const modal = (
    <div
      className="modal dismissible fade"
      id={props.modalId}
      aria-hidden="true"
      aria-labelledby="centerModal"
      role="dialog"
      tabIndex="-1"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div className="modal-dialog modal-simple modal-center">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={hideModal}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title">{props.modalTitle}</h4>
          </div>
          <div className="modal-body">{props.children}</div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default btn-pure"
              style={{ fontWeight: 400 }}
              data-dismiss="modal"
              data-bs-dismiss="modal"
              onClick={hideModal}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  if (typeof document === "undefined") {
    return null;
  }

  return ReactDOM.createPortal(modal, document.body);
};

export default centerModalNew;
